<template>
  <div class="pie_">
    <apexchart
      type="pie"
      :width="width"
      :options="options"
      :series="series"
    />
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    id: {
      type: String,
      default: 'noid'
    },
    width: {
      type: String,
      default: '110%'
    }
  },
  data () {
    return {
      series: [],
      colors: ['#673ab7', '#3F51B5', '#2196F3', '#5ad783', '#ffc107', '#ff5722', '#F44336', '#E91E63', '#CDDC39', '#9E9E9E'],
      options: {
        chart: {
          id: 'chartpie-' + this.id,
          width: '110%',
          type: 'pie',
          fontFamily: '"Open Sans", sans-serif'
        },
        plotOptions: {
          pie: {
            offsetX: 65,
            offsetY: -25,
            customScale: 0.79,
            dataLabels: {
              offset: 0,
              minAngleToShowLabel: 7
            }
          }
        },
        labels: [],
        legend: {
          show: true,
          floating: true,
          fontSize: '13px',
          position: 'left',
          offsetX: -32,
          offsetY: 0
        },
        responsive: [
          {
            breakpoint: 1599,
            options: {
              plotOptions: {
                pie: {
                  offsetX: 34,
                  offsetY: 0,
                  customScale: 1,
                }
              }
            }
          },
          {
            breakpoint: 1449,
            options: {
              plotOptions: {
                pie: {
                  offsetX: 0,
                  offsetY: 0,
                  customScale: 1,
                }
              },
              legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                offsetY: 0,
                floating: false
              }
            }
          },
          {
            breakpoint: 1025,
            options: {
              plotOptions: {
                pie: {
                  offsetX: 0,
                  offsetY: 40,
                  customScale: 1.4
                }
              },
              legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                offsetY: -25,
                floating: false
              }
            }
          }
        ]
      }
    }
  },
  watch: {
    value () {
      this.$nextTick(() => {
        this.updateChart()
      })
    }
  },
  methods: {
    updateChart () {
      if (this.value.length > 0) {
        let series = this.value.map(el => el.value) || []
        let labels = this.value.map(el => el.title) || []
        let colors = this.colors.sort(() => Math.random() - 0.5)
        this.$apexcharts.exec('chartpie-' + this.id, 'updateOptions', { labels, series, colors }, true, true)
        this.$apexcharts.exec('chartpie-' + this.id, 'updateSeries', series, true)
      }
    }
  },
  created () {
    this.updateChart()
  },
  mounted () {
    this.updateChart()
  }
}
</script>

<style lang="scss">
.apexcharts-canvas {
  #app & {
    .apexcharts-legend {
      position: relative;
      * {
        z-index: 99999 !important;
      }
      .apexcharts-legend-text {
        top: -1px;
      }
    }
    .apexcharts-inner {
      * {
        z-index: -1 !important;
      }
    }
  }
  #app.theme--light & {
    .apexcharts-legend .apexcharts-legend-text {
      color: #444 !important;
    }
  }
  #app.theme--dark & {
    .apexcharts-legend .apexcharts-legend-text {
      color: #f9f9f9 !important;
    }
    .apexcharts-pie-area {
      stroke: rgb(0, 0, 0) !important;
    }
  }
}
</style>

<style lang="scss">
#app .pie_ {
  display: contents;
  > div {
    margin: 0 auto !important;
  }
}
</style>